import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Icon } from "@iconify/react/dist/iconify.js";
import { Chip, Grid, IconButton, Stack, InputAdornment } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Card, Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import CustomButton from "../../components/Form/CustomButton";
import CustomTextField from "../../components/Form/CustomTextField";
import UploadProfileImg from "../../components/Form/UploadProfileImg";
import Header from "../../components/VerticalLayout/Header";
import { resetProfileState, updateProfile, verify_admin } from "../../store/actions";
import Label from "../../components/Common/Label";
import RenderPopOverButton from "../../components/Form/RenderPopOverButton";
import Table from "../../components/Common/Table";
import AppDialog from "../../components/Common/AppDialog";
import DeleteModal from "../../components/Common/DeleteModal";
import Helpers from "../../helpers/helpers";
import CustomSelect from "../../components/Form/CustomSelect";
import CheckBox from "../../components/Form/CheckBox";
import { DetailsOutlined } from "@mui/icons-material";


const UserProfile = ({ details, editUserProfile, error, userPermission, windowWidth,  leftSideBarType }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(resetProfileState());
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth); // Update state when window resizes
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-product") && setEditable(true);
            userPermission?.includes("create-product") && setDeletable(true);
        }
    }, [userPermission])

    const defaultValues = {
        fullName: "",
        email: "",
        phone: "",
        gender: "Choose",
        Nationality: "Choose",
        role: "Choose",
        password: "",
        status: "",
        joinedDate: "",
        openingHours: [],
    }

    const dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'PH'];
    const [width, setWidth] = useState(window.innerWidth);
    const [values, setFormValues] = useState(defaultValues);
    const [loading, setIsLoading] = useState(false);
    const [selected, setSelected] = useState("store_details");

    const [editable, setEditable] = useState(true);
    const [deletable, setDeletable] = useState(true);

    const [type, setType] = useState("Add");

    // Store Details
    const [isEditStore, setIsEditStore] = useState(false);
    const handleBannerChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        
        const reader = new FileReader();
        reader.onloadend = () => {
            handleFormObjectChange('banner_image', reader.result);
        };
        reader.readAsDataURL(file);
    };

    const handleCoverChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        
        const reader = new FileReader();
        reader.onloadend = () => {
            handleFormObjectChange('cover_image', reader.result);
        };
        reader.readAsDataURL(file);
    };

    // Salesman section
    const [addSalesmanOpen, setAddSalesmanOpen] = useState(false);
    const [selectedSalesman, setSelectedSalesman] = useState("");
    const [defaultOpen, setDefaultOpen] = useState(false);
    const [isEditSalesman, setIsEditSalesman] = useState(false); // for mobile size

    // Team members section
    const [inviteUserOpen, setInviteUserOpen] = useState(false);
    const [removeMemberOpen, setRemoveMemberOpen] = useState(false);
    const [selectedMember, setSelectedMember] = useState(false);
    const [assignManagerOpen, setAssignManagerOpen] = useState(false);

    // Profile info section
    const [isEdit, setIsEdit] = useState(false);

    // Password
    const [showPasswords, setShowPasswords] = useState({
        current: false,
        new: false,
        confirm: false
    });

    const [preview, setProfileImg] = useState("");
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [profileImgFile, setProfileImgFile] = useState();

    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setProfileImgFile(file);

        const reader = new FileReader();
        reader.onloadend = () => {
            setProfileImg(reader.result); // base64 string
        };
        reader.readAsDataURL(file);
    };
    useEffect(() => {
        setFormValues({
            name: details?.name || "",
            email: details?.email || "",
            phone: details?.phone || "",
            profile_photo: details?.profile_photo_path,
            profile_photo_name: details?.profile_photo_name,
            profile_photo_extension: details?.profile_photo_extension,
            joined_date: details?.joined_date === "0000-00-00" ? null : details?.joined_date,
        })
        setProfileImg(details?.profile_photo_path)
    }, [details])

    useEffect(() => {
        if (editUserProfile?.code === "success") {
            setNotification({
                open: true,
                msg: 'Profile updated successfully',
                type: 'success'
            })
            dispatch(resetProfileState());
            dispatch(verify_admin());
            setFormValues("")
        } else if (editUserProfile?.code === "failed" || editUserProfile?.code === "invalid_field") {
            setNotification({ open: true, msg: editUserProfile?.message || "Please fill in all required fields", type: "error" });
        }
        setIsLoading(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editUserProfile])

    // const handleFormObjectChange = (key, value) => {
    //     setFormValues((prevValues) => ({
    //         ...prevValues,
    //         [key]: value
    //     }));
    // }

    const handleFormObjectChange = (key, value, day) => {
        if (key === 'openingHours') {
            // Handle checkbox toggle
            setFormValues((prevValues) => {
                const currentHours = prevValues.openingHours || [];
                const existingIndex = currentHours.findIndex(item => item.day === value);
                
                if (existingIndex >= 0) {
                    // Day exists, toggle isChecked
                    const updatedHours = [...currentHours];
                    updatedHours[existingIndex] = {
                        ...updatedHours[existingIndex],
                        isChecked: !updatedHours[existingIndex].isChecked
                    };
                    return { ...prevValues, openingHours: updatedHours };
                } else {
                    // Day doesn't exist, add it
                    return {
                        ...prevValues,
                        openingHours: [...currentHours, {
                            day: value,
                            isChecked: true,
                            open_time: '-1',
                            close_time: '-1'
                        }]
                    };
                }
            });
        } else if (key === 'open_time' || key === 'close_time') {
            // Handle time selection
            setFormValues((prevValues) => {
                const currentHours = prevValues.openingHours || [];
                const existingIndex = currentHours.findIndex(item => item.day === day);
                
                if (existingIndex >= 0) {
                    const updatedHours = [...currentHours];
                    updatedHours[existingIndex] = {
                        ...updatedHours[existingIndex],
                        [key]: value
                    };
                    return { ...prevValues, openingHours: updatedHours };
                }
                return prevValues;
            });
        } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                [key]: value
            }));
        }
    }


    async function urlToBase64NoPrefix(url) {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                // Remove the prefix: "data:image/...;base64,"
                const base64 = reader.result.split(',')[1];
                resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    // dummy here
    const locationList = [
        { id: 1, name: "Kaki Bukit" },
        { id: 2, name: "Ubi" },
        { id: 3, name: "Sembawang" },
    ];

    const stateList = [
        { id: 1, name: "Singapore" },
        { id: 2, name: "Johor" },
        { id: 3, name: "Selangor" },
    ];

    const cityList = [
        { id: 1, name: "Singapore" },
        { id: 2, name: "Johor Bahru" },
        { id: 3, name: "Kuala Lumpur" },
    ];

    const review = "Enabled"

    const handlesubmit = async () => {
        setIsLoading(true);
        const images = await urlToBase64NoPrefix(preview);

        let payload = {
            email: values?.email,
            name: values?.name,
            phone: values?.phone,
            profile_photo: images,
            current_password: values?.current_password,
            new_password: values?.new_password,
            new_password_confirmation: values?.new_password_confirmation,
        }
        dispatch(updateProfile(payload))
    }

    const handleSendInvitation = () => {

    }

    const handleDefault = () => {

    }

    const handleAssignManager = () => {

    }

    const handleDelete = () => {

    }

    const header = [
        {
            Header: "Salesman name",
            accessor: (cellProps) => {
                return (<>{cellProps?.salesman_name || "-"} {cellProps?.status === "default" && <Chip style={{ backgroundColor: "#E7F2FC", color: "#3674B5", height: "25px", marginLeft: 2 }} label={cellProps?.status === "default" ? "Default" : ""} />}</>)
            },
        },
        {
            Header: "Location",
            accessor: (cellProps) => {
                return (cellProps?.location || "-")
            },
        },
        {
            Header: "Phone number",
            accessor: (cellProps) => {
                return (<div>{cellProps?.phone_number || "-"}</div>)
            },
        },
        {
            Header: " ",
            accessor: (cellProps) => {
                return (
                    <RenderPopOverButton
                        customTitle={<Icon icon="solar:menu-dots-bold" />}
                        items={[
                            { iconName: 'solar:flag-linear', label: 'Set as default', color: '#1D1B1B', permission: cellProps?.status === "default" && editable, onClick: () => { setDefaultOpen(true)} },
                            { iconName: 'solar:pen-linear', label: 'Edit Salesman', color: '#1D1B1B', permission: editable, onClick: () => { setAddSalesmanOpen(true); setType("Edit"); } },
                            { iconName: 'solar:user-cross-linear', label: 'Remove salesman', color: '#D13536', permission: deletable, onClick: () => { setSelectedSalesman(cellProps); setDeleteOpen(true) } },
                        ]}
                    />
                )
            },
        },
    ]

    const teamMembersHeader = [
        {
            Header: "Name",
            accessor: (cellProps) => {
                return (<>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px'}}>{cellProps?.salesman_name || "-"}
                    <Label.GeneralStatusLabel label={cellProps.status} list={Helpers.profileTeamMemberVerificationStatus} marginLeft={"0px"}/></div> 
                </>)
            }, 
        },
        {
            Header: "Role",
            accessor: (cellProps) => {
                return (cellProps?.location || "-")
            },
        },
        {
            Header: "Email address",
            accessor: (cellProps) => {
                return (<div>{cellProps?.phone_number || "-"}</div>)
            },
        },
        {
            Header: "Status",
            accessor: (cellProps) => {
                return (<div><Label.GeneralStatusLabel label={cellProps.status} list={Helpers.profileTeamMemberStatus} marginLeft={"0px"} /></div>)
            },
        },
        {
            Header: " ",
            accessor: (cellProps) => {
                return (
                    <RenderPopOverButton //only role = manager can shows popoverbutton on the member row, status invited will also not showing popoverbutton, will set the condition during api integration
                        customTitle={<Icon icon="solar:menu-dots-bold" />}
                        items={[
                            { iconName: 'solar:lock-keyhole-minimalistic-unlocked-linear', label: 'Assign as manager', color: '#1D1B1B', permission: editable, onClick: () => {setAssignManagerOpen(true);} },
                            { iconName: 'solar:user-cross-linear', label: 'Remove user', color: '#D13536', permission: deletable, onClick: () => { setSelectedMember(cellProps); setRemoveMemberOpen(true) } },
                        ]}
                    />
                )
            },
        },
    ]


    const renderContent = () => {
        switch (selected) {
            case "store_details":
                return !isEditStore ? (
                <>
                    {width > 768 ? (
                    <Stack spacing={0} style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center", }}>
                        <Stack display="flex" flexDirection="row" gap={2} alignItems="center" >
                            <img src={preview || "/images/users/default_user.png"} alt="profile" width={64} height={64} style={{ borderRadius: "50%", objectFit: "cover" }} />
                            <div style={{ flexDirection: "column", display: "flex", }}>
                                <span style={{ fontSize: "14px", fontWeight: 600 }}>{details?.store_name || "-"} <Chip label={details?.type || "-"} style={{ color: "white", backgroundColor: "#D13536", height: "20px", marginLeft: 2, marginBottom: 2 }} /></span>
                                <span className="text-muted">{details?.count || 0} members</span>
                            </div>
                        </Stack>
                        <div>
                            <CustomButton
                                title={"View on marketplace"}
                                paddingInline={25}
                                padding={18}
                                press={(e) => ""}
                                width={"100%"}
                                marginRight={10}
                            />
                        </div>
                    </Stack>
                    ) : (      

                   <Grid container sx={{marginBottom: 2}}>
                        <Stack spacing={2} style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center" }}>
                            <Stack display="flex" flexDirection="row" gap={2} alignItems="center" >
                                <img src={preview || "/images/users/default_user.png"} alt="profile" width={64} height={64} style={{ borderRadius: "50%", objectFit: "cover" }} />
                                <div style={{ flexDirection: "column", display: "flex", }}>
                                    <span style={{ fontSize: "16px", fontWeight: 600, }}>{details?.store_name || "-"} <Chip label={details?.type || "-"} style={{ marginLeft: 2, color: "white", backgroundColor: "#D13536", height: "20px" }} /></span>
                                    <span className="text-muted">{details?.count || 0} members</span>
                                </div>
                            </Stack>
                        </Stack>

                        <Grid item xs={12} sx={{marginTop: 2}}>     
                                <CustomButton
                                    width={'100%'}
                                    height={'80%'}
                                    title={"View on marketplace"}
                                    press={(e) => ""}
                                />
                        </Grid>
                    </Grid> 
                )}

                    <Grid container spacing={2} pt={2}>
                        <Grid item xs={12} display={"flex"} direction="column">
                            <span className="text-muted font-size-12 pb-1">Store name</span>
                            <span className="font-size-14">{details?.store_name || "-"}</span>
                        </Grid>
                        <Grid item xs={12} display={"flex"} direction="column">
                            <span className="text-muted font-size-12 pb-1">Registration number / UEN</span>
                            <span className="font-size-14">{details?.registration_number || "-"}</span>
                        </Grid>
                        <Grid item xs={12} display={"flex"} direction="column">
                            <span className="text-muted font-size-12 pb-1">Short business description</span>
                            <span className="font-size-14">{details?.short_business_description || "-"}</span>
                        </Grid>
                        <Grid item xs={12} display={"flex"} direction="column">
                            <span className="text-muted font-size-12 pb-1">Website URL</span>
                            <span className="font-size-14">{details?.website_url || "-"}</span>
                        </Grid>
                        <Grid item xs={12} display={"flex"} direction="column">
                            <span className="text-muted font-size-12 pb-1">Banner image</span>
                            <img width="240px" height="76px" alt="banner-image" src={details?.banner_image || "-"} />
                        </Grid>
                        <Grid item xs={12} display={"flex"} direction="column">
                            <span className="text-muted font-size-12 pb-1">Cover image</span>
                            <img width="240px" height="76px" alt="cover-image" src={details?.cover_image || "-"} />
                        </Grid>
                        <Grid item xs={12} display={"flex"} direction="column" spacing={2}>
                            <span className="text-muted font-size-12 pb-1">Operating hours</span>
                            <Stack spacing={1}>
                                {details?.operating_hours?.length > 0 ? details?.operating_hours.map((item, index) => (
                                    <div key={index} className="font-size-14 d-flex" spacing={1}>
                                        <span style={{minWidth: '160px'}}>{item.day}</span>
                                        <span>{item.opening_time} - {item.closing_time}</span>
                                    </div>
                                )) : <div className="font-size-14">-</div>}
                            </Stack>
                        </Grid>
                        <Grid item xs={12} display={"flex"} direction="column" spacing={2}>
                            <span className="text-muted font-size-12 pb-1">Address</span>
                            <iframe
                                width="240"
                                height="136"
                                frameBorder="0"
                                scrolling="no"
                                marginHeight="0"
                                marginWidth="0"
                                src={`https://maps.google.com/maps?width=100%25&height=600&hl=en&q=${details?.latitude},${details?.longitude}&t=&z=14&ie=UTF8&iwloc=B&output=embed`}
                            />
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: width > 768 ? 'center' : 'flex-start', gap: '4px', marginTop: "2px" }}>
                                <Icon icon="solar:map-point-linear" width={width > 768 ? 14 : 22} height={14} style={{marginTop: width > 768 ? 0 : 5}} />
                                <div>17 Yishun Industrial Street 1 #01-55, North Spring Bizhu, 768163 Singapore</div>
                            </div>
                        </Grid>

                        <Grid item xs={12} display={"flex"} direction="column" spacing={2}>
                            <span className="text-muted font-size-12 pb-1">Region</span>
                            <div>Central</div>
                        </Grid>

                        <Grid item xs={12} display={"flex"} direction="column" spacing={2}>
                            <span className="text-muted font-size-12 pb-1">Google review link</span>
                            <div>https://goo.gl/maps/xxxxxx....</div>
                        </Grid>

                        <Grid item xs={12} display={"flex"} direction="column" spacing={2}>
                            <span className="text-muted font-size-12 pb-1">Google review status</span>
                            <div><Label.GeneralStatusLabel label={review.status} list={Helpers.advertStatus} marginLeft={"0px"} /></div>
                        </Grid>

                        <Grid item xs={12} pt={2}>
                            <CustomButton
                                title="Edit"
                                press={() => {
                                    setIsEditStore(true);
                                }}
                                textColor={"#808588"}
                                backgroundColor={"#F9F9F9"}
                                borderStyle={"#F9F9F9"}
                                height={"36px"}
                                width={"97px"}
                            />
                        </Grid>
                    </Grid>
                </>) : (  <div>
                <Stack spacing={2} pb={3} style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center" }}>
                    <Stack display="flex" flexDirection="row" gap={2} alignItems="center">
                        <div style={{ position: 'relative' }}>
                            <div style={{
                                width: 64,
                                height: 64,
                                borderRadius: '50%',
                                backgroundColor: '#D13536',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <Icon icon="solar:fire-bold" color="white" width={32} height={32} />
                            </div>
                        </div>
                        <Stack direction="row" gap={2}>
                            <CustomButton
                                title="Upload"
                                press={() => {
                                    document.getElementById('store-logo-upload').click();
                                }}
                                backgroundColor="#1D1B1B"
                                textColor="white"
                                height="36px"
                                width="auto"
                            />
                            <input
                                id="store-logo-upload"
                                type="file"
                                accept="image/*"
                                style={{ display: 'none' }}
                                onChange={handleImageChange}
                            />
                            <CustomButton
                                title="Remove"
                                press={() => {
                                    setProfileImg("/images/users/default_user.png");
                                }}
                                backgroundColor="#F9F9F9"
                                textColor="#808588"
                                height="36px"
                                width="auto"
                            />
                        </Stack>
                    </Stack>
                </Stack>

                <Grid container spacing={1}>
                    <Grid item xs={width > 768 ? 6 : 12}>
                        <CustomTextField
                            title="Store name"
                            values={values?.store_name || ''}
                            onChange={(e) => handleFormObjectChange('store_name', e)}
                            placeholder="Enter store name"
                            paddingBlock="8px"
                        />
                    </Grid>

                    <Grid item xs={width > 768 ? 6 : 12}>
                        <CustomTextField
                            title="Registration number / UEN"
                            values={values?.registration_number || ''}
                            onChange={(e) => handleFormObjectChange('registration_number', e)}
                            placeholder="Enter registration number"
                            paddingBlock="8px"
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <CustomTextField
                            title="Short business description"
                            values={values?.short_business_description || ''}
                            onChange={(e) => handleFormObjectChange('short_business_description', e)}
                            placeholder="Enter short business description"
                            paddingBlock="8px"
                            multiline
                            rows={3}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <CustomTextField
                            values={values?.website_url || ''}
                            onChange={(e) => handleFormObjectChange('website_url', e)}
                            placeholder="Website URL"
                            paddingBlock="8px"
                            sx={{marginBottom: 1}}
                        />
                    </Grid>

                    <Grid item xs={12} sx={{marginTop: width > 768 ? 0 : 2}}>
                        <Stack spacing={1}>
                            <span style={{ fontSize: 14, fontWeight: 500 }}>Banner Image</span>
                            <div style={{ position: 'relative', width: 'fit-content' }}>
                                <img 
                                    width="240px" 
                                    height="136px" 
                                    alt="banner-image" 
                                    src={values?.banner_image || "/images/store/banner_sample.png"}
                                    style={{ borderRadius: 8, objectFit: 'cover' }}
                                />
                                <div style={{
                                    position: 'absolute',
                                    bottom: 8,
                                    left: 8,
                                    right: 8,
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }}>
                                <IconButton
                                    onClick={() => handleFormObjectChange('banner_image', null)}
                                    style={{
                                        backgroundColor: 'white',
                                        width: 32,
                                        height: 32,
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}
                                >
                                <Icon icon="solar:trash-bin-trash-linear" color="#D13536" width={18} height={18} />
                                </IconButton>
                                <IconButton
                                    onClick={() => document.getElementById('banner-upload').click()}
                                    style={{
                                        backgroundColor: 'white',
                                        width: 32,
                                        height: 32,
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}
                                >
                                <Icon icon="solar:pen-linear" width={18} height={18} />
                                </IconButton>
                                <input
                                    id="banner-upload"
                                    type="file"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    onChange={(e) => handleBannerChange(e)}
                                />
                                </div>
                            </div>
                        </Stack>
                    </Grid>

                    <Grid item xs={12}>
                        <Stack spacing={1}>
                            <span style={{ fontSize: 14, fontWeight: 500 }}>Cover image</span>
                            <div style={{ position: 'relative', width: 'fit-content' }}>
                                <img 
                                    width="240px" 
                                    height="136px" 
                                    alt="cover-image" 
                                    src={values?.cover_image || "/images/store/cover_sample.png"}
                                    style={{ borderRadius: 8, objectFit: 'cover' }}
                                />
                                <div style={{
                                    position: 'absolute',
                                    bottom: 8,
                                    left: 8,
                                    right: 8,
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }}>
                                    <IconButton
                                        onClick={() => {
                                            handleFormObjectChange('cover_image', null)
                                        }}
                                        style={{
                                            backgroundColor: 'white',
                                            width: 32,
                                            height: 32,
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                        }}
                                    >
                                    <Icon icon="solar:trash-bin-trash-linear" color="#D13536" width={18} height={18} />
                                    </IconButton>
                                    <IconButton
                                        onClick={() => document.getElementById('cover-upload').click()}
                                        style={{
                                            backgroundColor: 'white',
                                            width: 32,
                                            height: 32,
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                        }}
                                    >
                                    <Icon icon="solar:pen-linear" width={18} height={18} />
                                    </IconButton>
                                    <input
                                        id="cover-upload"
                                        type="file"
                                        accept="image/*"
                                        style={{ display: 'none' }}
                                        onChange={(e) => handleCoverChange(e)}
                                    />
                                </div>
                            </div>
                        </Stack>
                    </Grid>

                    <Grid item xs={12} mt={2}>
                        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>Opening hours</div>
                        <div style={{ fontSize: 14, color: '#808588' }}>Set the workshop/office working hours to show on your profile page</div>
                    </Grid>
                    {
                        dayList.map((day, idx) => (
                            <Grid item container xs={12} sm={12} spacing={2}>
                                <Grid item xs={3} sm={3} className="d-flex align-items-center">
                                    <CheckBox label={day} labelMarginLeft={width > 768 ? 20 : 3} values={values?.openingHours?.find((item) => item?.day === day)?.isChecked || false}  onChange={(e) => { handleFormObjectChange('openingHours', day) }} />
                                </Grid>
                                <Grid item xs={4} sm={4}>
                                    <CustomSelect
                                        width={width > 768 ? undefined : 100}
                                        height={width > 768 ? undefined : 70}
                                        title={'Opening time'}
                                        values={values?.openingHours?.find((item) => item?.day === day && item?.isChecked)?.open_time || '-1'}
                                        data={Helpers.timeList}
                                        disabled={!(values?.openingHours?.find((item) => item?.day === day && item?.isChecked))}
                                        onChange={(e) => handleFormObjectChange('open_time', e, day)}
                                        placeholder={'Opening time'}
                                        isMobile={true}
                                    />
                                </Grid>
                                <Grid item xs={1} sm={1} className="d-flex align-items-center justify-content-center">to</Grid>
                                <Grid item xs={2} sm={4}>
                                    <CustomSelect
                                        width={width > 768 ? undefined : 100}
                                        height={width > 768 ? undefined : 70}
                                        values={values?.openingHours?.find((item) => item?.day === day && item?.isChecked)?.close_time || '-1'}
                                        data={Helpers.timeList}
                                        disabled={!(values?.openingHours?.find((item) => item?.day === day && item?.isChecked))}
                                        onChange={(e) => handleFormObjectChange('close_time', e, day)}
                                        placeholder={'Closing time'}
                                        title={'Closing time'}
                                        isMobile={true}
                                    />
                                </Grid>
                            </Grid>
                        ))
                    }

                    <Grid item xs={12} mt={2}>
                        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 1 }}>Location</div>
                        <div style={{ fontSize: 14, color: '#808588', }}>Add your company address</div>
                    </Grid>

                    <Grid item xs={12}>
                        <CustomTextField
                            title="Street address"
                            values={values?.street_address || ''}
                            onChange={(e) => handleFormObjectChange('street_address', e)}
                            placeholder="Enter street address"
                            paddingBlock="8px"
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <CustomTextField
                            values={values?.apartment || ''}
                            onChange={(e) => handleFormObjectChange('apartment', e)}
                            placeholder="Apartment, building, floor, unit, etc (optional)"
                            paddingBlock="8px"
                            sx={{marginBottom: 1}}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <CustomSelect
                            title="State"
                            placeholder="Select state"
                            values={values?.state || '-1'}
                            onChange={(value) => handleFormObjectChange('state', value)}
                            data={stateList}
                            valueName="id"
                            labelName="name"
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <CustomSelect
                            title="City"
                            placeholder="Select city"
                            values={values?.city || '-1'}
                            onChange={(value) => handleFormObjectChange('city', value)}
                            data={cityList}
                            valueName="id"
                            labelName="name"
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <CustomTextField
                            title="Postal code"
                            values={values?.postal_code || ''}
                            onChange={(e) => handleFormObjectChange('postal_code', e)}
                            placeholder="Enter postal code"
                            paddingBlock="8px"
                            type="number"
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <CustomTextField
                            title="Region"
                            values={values?.region || ''}
                            onChange={(e) => handleFormObjectChange('region', e)}
                            placeholder="Enter region"
                            paddingBlock="8px"
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <CustomTextField
                            title="Google map link (optional)"
                            values={values?.google_map_link || ''}
                            onChange={(e) => handleFormObjectChange('google_map_link', e)}
                            placeholder="Enter Google map link"
                            paddingBlock="8px"
                        />
                    </Grid>

                    <Grid item xs={12} mt={2}>
                        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>Google Review</div>
                        <div style={{ fontSize: 14, color: '#808588' }}>Paste your Google Reviews URL from Google Business Profile.</div>
                    </Grid>

                    <Grid item xs={12}>
                        <CustomTextField
                            title="Google review link (optional)"
                            values={values?.google_review_link || ''}
                            onChange={(e) => handleFormObjectChange('google_review_link', e)}
                            placeholder="Enter Google review link"
                            paddingBlock="8px"
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} sx={{marginTop: 1}}>
                        <CheckBox 
                            label="Display google review section on dealer profile" 
                            labelMarginLeft={8}
                            labelWhiteSpace={'normal'}
                            values={values?.display_google_review || false} 
                            onChange={(e) => handleFormObjectChange('display_google_review', !values?.display_google_review)} 
                            fontSize={14}
                        />
                    </Grid>

                    <Grid item xs={12} pt={2}>
                        <Stack direction="row" spacing={2} gap={1}>
                            <CustomButton
                                title="Save changes"
                                press={() => {
                                    handlesubmit();
                                    setIsEditStore(false);
                                }}
                                backgroundColor="#1D1B1B"
                                textColor="white"
                                height="36px"
                                width="150px"
                            />
                            <CustomButton
                                title="Cancel"
                                press={() => {
                                    setIsEditStore(false);
                                    // Reset form values if needed
                                }}
                                backgroundColor="#F9F9F9"
                                textColor="#808588"
                                height="36px"
                                width="115px"
                                borderStyle={"none"}
                            />
                        </Stack>
                    </Grid>
                </Grid>
                </div>);
            case "salesman":
                return <div>
                    <Stack spacing={2} pb={width > 768 ? 2 : 0} style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center" }}>
                        <span style={{ fontSize: "16px", fontWeight: 600 }}>Salesman</span>
                        <div className="m-0 p-0">
                            <CustomButton
                                title={width > 768 ? "Add new salesman" : "Add salesman"}
                                press={() => setAddSalesmanOpen(true)}
                            />
                        </div>
                    </Stack>
                    {width > 768 ? (
                    <Table
                        header={header}
                        data={details?.salesman || []}
                        pageSize={details?.salesman?.length}
                        totalPage={1}
                        headerBackground={"#F5F5F5"}
                        headerTitleColor={"#808588"}
                    />
                    ) : (
                        !isEditSalesman ? (
                        <div>
                            {details?.salesman && details.salesman.length > 0 ? (
                                details?.salesman?.map((salesman, index) => (
                                <div key={index} className="mt-3 dashboard-card">
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontSize: '16px', fontWeight: 600, marginBottom: '8px' }}>
                                                {'Steven Lee' || '-'}
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#808588', fontSize: '14px', marginBottom: '5px' }}>
                                                <Icon icon="solar:map-point-linear" width={16} height={16} />
                                                <span>{salesman.location || 'Kaki Bukit'}</span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#808588', fontSize: '14px' }}>
                                                <Icon icon="solar:phone-linear" width={16} height={16} />
                                                <span>{'+6586660033' || '-'}</span>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '12px', marginLeft: '16px' }}>
                                            <Icon 
                                                icon="solar:pen-linear" 
                                                width={20} 
                                                height={20} 
                                                style={{ cursor: 'pointer', color: '#808588' }}
                                                onClick={() => {
                                                    setIsEditSalesman(true)
                                                }}
                                            />
                                            <Icon 
                                                icon="solar:trash-bin-trash-linear" 
                                                width={20} 
                                                height={20} 
                                                style={{ cursor: 'pointer', color: '#ef4444' }}
                                                onClick={() => {
                                                    setDeleteOpen(true)
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))) : (<div style={{
                                    marginTop: '16px',
                                    padding: '50px 20px',
                                    border: '2px dashed #E0E0E0',
                                    borderRadius: '8px',
                                    textAlign: 'center',
                                    backgroundColor: '#FAFAFA'
                                }}>
                                    <Icon 
                                        icon="solar:file-text-linear"
                                        width={48} 
                                        height={48} 
                                        style={{ color: '#D0D0D0', marginBottom: '12px' }}
                                    />
                                    <div style={{ color: '#A0A0A0', fontSize: '14px' }}>
                                        No added salesman yet
                                    </div>
                                </div>)}
                        </div>
                        ) : (       
                        <div className="mt-3 dashboard-card">  
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <CustomTextField
                                        title="Salesman"
                                        values={values?.salesmanName}
                                        onChange={(e) => handleFormObjectChange('salesmanName', e)}
                                        placeholder="Enter salesman name"
                                        paddingBlock="8px"
                                />
                                </Grid>
                                
                                <Grid item xs={12}>
                                    <CustomSelect
                                        title="Location"
                                        placeholder="Choose a location"
                                        values={values?.location}
                                        onChange={(value) => handleFormObjectChange('location', value)}
                                        data={locationList}
                                        valueName="id"
                                        labelName="name"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <CustomTextField
                                        title="Contact"
                                        values={values?.salesmanName}
                                        onChange={(e) => handleFormObjectChange('salesmanName', e)}
                                        placeholder="Enter phone number"
                                        paddingBlock="8px"
                                />
                                </Grid>

                                <Grid item xs={12} pt={2}  sx={{marginTop: 2}}>
                                    <Stack direction="row" spacing={2} gap={2}>
                                        <CustomButton
                                            title="Cancel"
                                            press={() => {
                                                setIsEditSalesman(false);
                                                // Reset form values if needed
                                            }}
                                            backgroundColor="#F9F9F9"
                                            textColor="#808588"
                                            height="36px"
                                            width="115px"
                                        />
                                        <CustomButton
                                            title="Save"
                                            press={() => {
                                                handlesubmit();
                                                setIsEditSalesman(false);
                                            }}
                                            backgroundColor="#1D1B1B"
                                            textColor="white"
                                            height="36px"
                                            width="150px"
                                        />
                                        </Stack>
                                    </Grid>
                            </Grid>
                        </div>)
                    )}
                    <AppDialog
                        open={addSalesmanOpen}
                        close={() => {setAddSalesmanOpen(false); setTimeout(() => setType('Add'), 200);}}
                        title={type === 'Edit' ? 'Edit salesman': 'Add new salesman'}
                        positiveTitle={type === 'Edit' ? 'Save changes' : 'Confirm'}
                        positivePress={() => {handleSendInvitation(false); setTimeout(() => setType('Add'), 200);}}
                        negativeTitle={'Cancel'}
                        negativePress={() => {setAddSalesmanOpen(false); setTimeout(() => setType('Add'), 200);}}
                        negativeButtonStyle={{ color: "#808588", backgroundColor: "#F9F9F9", border: "0px solid black", width: "auto", borderRadius: "20px"}}
                        width={'30%'}
                        isMobile={width <= 768 ? true : false}
                        mobileSizeModalMaxHeight={"80%"}
                    >
                        <Grid container spacing={1}>
                            {type !== "Edit" && (
                                <Grid item xs={12}>
                                    <div className="text-muted">Enter the salesman info to add them to Auto Works Pte Ltd..</div>
                                </Grid>
                            )}

                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Salesman name"
                                    values={values?.salesmanName}
                                    onChange={(e) => handleFormObjectChange('salesmanName', e)}
                                    placeholder="Enter salesman name"
                                    paddingBlock="8px"
                            />
                            </Grid>

                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Phone Number"
                                    values={values?.phoneNumber}
                                    onChange={(e) => handleFormObjectChange('phoneNumber', e)}
                                    placeholder="Enter phone number"
                                    paddingBlock="8px"
                                    type="phone"
                                    InputProps={{
                                        startAdornment: (
                                            <div style={{ 
                                                paddingRight: 10, 
                                                paddingLeft: 10,
                                                color: '#101010' ,
                                                borderRight: '1.5px solid #E6E6E6',
                                            }}>
                                                +65
                                            </div>
                                        ),
                                    }}
                                />
                            </Grid>
                            
                            <Grid item xs={12}>
                                <CustomSelect
                                    title="Location"
                                    placeholder="Choose a location"
                                    values={values?.location}
                                    onChange={(value) => handleFormObjectChange('location', value)}
                                    data={locationList}
                                    valueName="id"
                                    labelName="name"
                                />
                            </Grid>
                        </Grid>
                    </AppDialog>

                    <AppDialog
                        open={defaultOpen}
                        close={() => setDefaultOpen(false)}
                        title={'Set as default'}
                        positiveTitle={'Set as default'}
                        positiveButtonStyle={{ color: "white", borderRadius: "20px", backgroundColor: "black", border: "1px solid black", width: width > 768 ? "auto" : "50%",}}
                        negativeButtonStyle={{ backgroundColor: "#F9F9F9", color: "#808588", border: "none", borderRadius: "20px", width: width > 768 ? "auto" : "50%" }}  
                        negativeTitle={'Cancel'}
                        positivePress={() => handleDefault()}
                        negativePress={() => setDefaultOpen(false)}
                        width={'30%'}
                        isMobile={width <= 768 ? true : false}
                    >
                        <Grid container>
                            <Grid item xs={12}>
                                <div className="" style={{fontSize: width > 768 ? undefined : 15}}>Are you sure you want to set <strong>{"salesman name"}</strong> as the <strong>default contact person</strong> for this dealer?</div>
                            </Grid>

                            <Grid container style={{ marginTop: '20px', border: "none", backgroundColor: "#F0F0F0", padding: "15px", borderRadius: "8px", marginBottom: "20px", borderLeft: "1px solid #1D1B1B" }}>
                                <Grid item xs={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    <div style={{border: "1px solid white", borderRadius: "100px", display: "inline-flex", padding: "4px", backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '32px', height: '32px',}}>
                                        <Icon icon="solar:lightbulb-linear"/>
                                    </div>
                                </Grid>
                                <Grid item xs={11} style={{display: 'flex', alignItems: 'center', paddingLeft: 8}}>
                                    Once confirmed, this salesman will appear as the primary contact on all new adverts created                    
                                </Grid>
                            </Grid>
                        </Grid>
                    </AppDialog>

                    {/* Delete modal for salesman*/}
                    <DeleteModal
                        open={deleteOpen}
                        onClose={() => setDeleteOpen(false)}
                        onDelete={handleDelete}
                        title='Remove Salesman'
                        message={'Are you sure you want to remove this salesman from your team?'}
                        positiveTitle='Remove'
                        positiveButtonStyle={{ 
                            backgroundColor: '#D13536', 
                            color: "white", 
                            border: "none", 
                            borderRadius: "20px",
                            width: width > 768 ? "auto" : "50%",
                        }}
                        negativeButtonStyle={{
                            width: width > 768 ? "auto" : "50%",
                            color: "#808588", 
                            backgroundColor:"#F9F9F9", 
                            border: "0px solid black",  
                            borderRadius: "20px",
                        }}
                        close={() => setDeleteOpen(false)}
                        width={"30%"}
                        isMobile={width <= 768 ? true : false}
                        mobileSizeModalMaxHeight={"43vh"}
                    />
                </div>;
            case 'team_members':
                    return <div>
                        <Stack spacing={2} pb={2} style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center" }}>
                            {width > 768 ? (<span style={{ fontSize: "16px", fontWeight: 600 }}>Team Members (len)</span>) : (<span style={{ fontSize: "14px", fontWeight: 600 }}>Team Members</span>)}
                            <div className="m-0 p-0">
                                <CustomButton
                                    title={width > 768 ? "Invite new user" : "Invite new users"}
                                    press={() => setInviteUserOpen(true)}
                                />
                            </div>
                        </Stack>
                    {width > 768 ? (
                        <Table
                            header={teamMembersHeader}
                            data={details?.salesman || []}
                            pageSize={details?.salesman?.length}
                            totalPage={1}
                            headerBackground={"#F5F5F5"}
                            headerTitleColor={"#808588"}
                        />
                    ) : (
                        <div>
                            {details?.salesman?.map((salesman, index) => (
                                <div key={index} className="mt-3 dashboard-card">
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                        <div style={{ flex: 1 }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '16px', fontWeight: 600, marginBottom: '8px' }}>
                                                <span>{'Rachel Ong' || '-'}</span>
                                                <Label.GeneralStatusLabel label={salesman.status} list={Helpers.profileTeamMemberStatus} marginLeft={"0px"} />
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#808588', fontSize: '14px', marginBottom: '5px' }}>
                                                <Icon icon="fluent:slide-text-person-20-regular" width={16} height={16} />
                                                <span>{salesman.location || '-'}</span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#808588', fontSize: '14px' }}>
                                                <Icon icon="fluent:mail-20-regular" width={16} height={16} />
                                                <span>{'rachelong@gmail.com' || '-'}</span>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '12px', marginLeft: '16px' }}>
                                            <Icon 
                                                icon="solar:pen-linear" 
                                                width={20} 
                                                height={20} 
                                                style={{ cursor: 'pointer', color: '#808588' }}
                                                onClick={() => {
                                                    setIsEditSalesman(true)
                                                }}
                                            />
                                            <Icon 
                                                icon="solar:trash-bin-trash-linear" 
                                                width={20} 
                                                height={20} 
                                                style={{ cursor: 'pointer', color: '#ef4444' }}
                                                onClick={() => {
                                                    setRemoveMemberOpen(true)
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                        <AppDialog
                            open={inviteUserOpen}
                            close={() => setInviteUserOpen(false)}
                            title={'Invite new member to team'}
                            positiveTitle={'Send invitation'}
                            positiveButtonStyle={{ color: "white", borderRadius: "20px", backgroundColor: "black", border: "1px solid black", width: width > 768 ? "auto" : "50%",}}
                            negativeButtonStyle={{ backgroundColor: "#F9F9F9", color: "#808588", border: "none", borderRadius: "20px", width: width > 768 ? "auto" : "50%" }}  
                            negativeTitle={'Cancel'}
                            positivePress={() => handleSendInvitation(false)}
                            negativePress={() => setInviteUserOpen(false)}
                            width={'30%'}
                            isMobile={width <= 768 ? true : false}
                            mobileSizeModalMaxHeight={"55%"}
                        >
                            <Grid container>
                                <Grid item xs={12}>
                                    <div className="text-muted" style={{fontSize: width > 768 ? undefined : 15}}>Enter the member's email address to invite them to Auto Works Pte Ltd.</div>
                                </Grid>

                                <Grid item xs={12} sx={{marginTop: width > 768 ? undefined : 2}}>
                                    <CustomTextField
                                        title="Email address"
                                        values={values?.email}
                                        onChange={(e) => handleFormObjectChange('email', e)}
                                        placeholder="Enter email address"
                                        paddingBlock="8px"
                                />
                                </Grid>
                            </Grid>
                        </AppDialog>

                        <AppDialog
                            open={assignManagerOpen}
                            close={() => setAssignManagerOpen(false)}
                            title={'Assign dealer manager'}
                            positiveTitle={'Assign manager'}
                            positiveButtonStyle={{ color: "white", borderRadius: "20px", backgroundColor: "black", border: "1px solid black", width: width > 768 ? "auto" : "50%",}}
                            negativeButtonStyle={{ backgroundColor: "#F9F9F9", color: "#808588", border: "none", borderRadius: "20px", width: width > 768 ? "auto" : "50%" }}  
                            negativeTitle={'Cancel'}
                            positivePress={() => handleAssignManager()}
                            negativePress={() => setAssignManagerOpen(false)}
                            width={'30%'}
                            isMobile={width <= 768 ? true : false}
                        >
                            <Grid container>
                                <Grid item xs={12}>
                                    <div className="" style={{fontSize: width > 768 ? undefined : 15}}>You are about to assign <strong>{"member name"}</strong> as the <strong>Dealer Manager</strong> for this dealer.</div>
                                </Grid>

                                <Grid container style={{ marginTop: '20px', border: "none", backgroundColor: "#F4C06D33", padding: "15px", borderRadius: "8px", marginBottom: "20px", borderLeft: "1px solid #F4C06D" }}>
                                    <Grid item xs={1}>
                                        <div style={{border: "1px solid white", borderRadius: "100px", display: "inline-flex", padding: "4px", backgroundColor: 'white', marginTop: '5px'}}>
                                            <Icon icon="solar:danger-triangle-linear"/>
                                        </div>
                                    </Grid>
                                    <Grid item xs={11} sx={{paddingLeft: 0.5}}>
                                        Each dealer team can only have <strong>one</strong> manager at a time. Once assigned, <strong>you will no longer have manager permissions</strong>, but will remain as a dealer user in the team.                     
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <div className="" style={{fontSize: width > 768 ? undefined : 15}}>Are you sure you want to proceed?</div>
                                </Grid>
                            </Grid>
                        </AppDialog>

                        {/* Delete modal for team members*/}
                        <DeleteModal
                            open={removeMemberOpen}
                            title='Remove Member'
                            message={'Are you sure you want to remove this member from your team?'}
                            positiveTitle='Remove'
                            positiveButtonStyle={{ 
                                backgroundColor: '#D13536', 
                                color: "white", 
                                border: "none", 
                                borderRadius: "20px",
                                width: width > 768 ? "auto" : "50%",
                            }}
                            negativeButtonStyle={{
                                width: width > 768 ? "auto" : "50%",
                                color: "#808588", 
                                backgroundColor:"#F9F9F9", 
                                border: "0px solid black",  
                                borderRadius: "20px",
                            }}
                            close={() => setRemoveMemberOpen(false)}
                            width={"35%"}
                            height={"10%"}
                            submit={() => {handleDelete()}}
                            isMobile={width <= 768 ? true : false}
                            mobileSizeModalMaxHeight={"43vh"}
                        />
                    </div>;
                case 'profile_info':
                    return !isEdit ? (
                        <div>
                            <Stack spacing={2} pb={3} style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center" }}>
                                <Stack display="flex" flexDirection="row" gap={2} alignItems="center">
                                    <img 
                                        src={preview || "/images/users/default_user.png"} 
                                        alt="profile" 
                                        width={64} 
                                        height={64} 
                                        style={{ borderRadius: "50%", objectFit: "cover" }} 
                                    />
                                    <div style={{ flexDirection: "column", display: "flex" }}>
                                        <Stack direction="row" alignItems="center" gap={1}>
                                            <span style={{ fontSize: "16px", fontWeight: 600, }}>{"Rachel Ong" || "-"}</span>
                                            <Label.GeneralStatusLabel label={0} list={Helpers.profileTeamMemberStatus} marginLeft={"0px"} />
                                        </Stack>
                                        <span className="text-muted font-size-14">{"weiyi@autowork.com" || "-"}</span>
                                    </div>
                                </Stack>
                            </Stack>

                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <span className="text-muted font-size-12">Name</span>
                                    <div className="font-size-14 pt-1">{"Rachel Ong" || "-"}</div>
                                </Grid>

                                <Grid item xs={12}>
                                    <span className="text-muted font-size-12">Email address</span>
                                    <div className="font-size-14 pt-1">{"rachelong@autoworks.com" || "-"}</div>
                                </Grid>

                                <Grid item xs={12}>
                                    <span className="text-muted font-size-12">Phone number</span>
                                    <div className="font-size-14 pt-1">{"+6591234567" || "-"}</div>
                                </Grid>

                                <Grid item xs={12} pt={2}>
                                    <CustomButton
                                        title="Edit"
                                        press={() => {
                                            setIsEdit(true);
                                        }}
                                        textColor={"#808588"}
                                        backgroundColor={"#F9F9F9"}
                                        borderStyle={"#F9F9F9"}
                                        height={"36px"}
                                        width={"97px"}
                                    />
                                </Grid>
                            </Grid>
                        </div>) : (
                        
                        // if isEdit is true
                        <div>
                            <Stack spacing={2} pb={2} style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center" }}>
                                <Stack display="flex" flexDirection="row" gap={2} alignItems="center">
                                    <img 
                                        src={preview || "/images/users/default_user.png"} 
                                        alt="profile" 
                                        width={64} 
                                        height={64} 
                                        style={{ borderRadius: "50%", objectFit: "cover" }} 
                                    />
                                        <Stack direction="row" gap={2}>
                                            <CustomButton
                                                title="Upload"
                                                press={() => {
                                                    document.getElementById('profile-upload-input').click();
                                                }}
                                                backgroundColor="#1D1B1B"
                                                textColor="white"
                                                height={"36px"}
                                                width={width > 768 ? "auto" : "100px" }
                                            />
                                            <input
                                                id="profile-upload-input"
                                                type="file"
                                                accept="image/*"
                                                style={{ display: 'none' }}
                                                onChange={handleImageChange}
                                            />
                                            <CustomButton
                                                title="Remove"
                                                press={() => {
                                                    setProfileImg("/images/users/default_user.png");
                                                    setProfileImgFile(null);
                                                }}
                                                backgroundColor={"#F9F9F9"}
                                                textColor="#808588"
                                                height="36px"
                                                width={width > 768 ? "auto" : "100px" }
                                                borderStyle={width > 768 ? undefined : "none"}
                                            />
                                        </Stack>
                                </Stack>
                            </Stack>
                            
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Name"
                                    values={values?.name || ''}
                                    onChange={(e) => handleFormObjectChange('name', e)}
                                    placeholder="Enter name"
                                    paddingBlock="8px"
                                />
                            </Grid>
                            
                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Email address"
                                    values={values?.email}
                                    onChange={(e) => handleFormObjectChange('email', e)}
                                    placeholder="Enter email address"
                                    paddingBlock="8px"
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Phone Number"
                                    values={values?.phoneNumber}
                                    onChange={(e) => handleFormObjectChange('phoneNumber', e)}
                                    placeholder="Enter phone number"
                                    paddingBlock="8px"
                                    type="phone"
                                    InputProps={{
                                        startAdornment: (
                                            <div style={{ 
                                                paddingRight: 10, 
                                                paddingLeft: 10,
                                                color: '#101010' ,
                                                borderRight: '1.5px solid #E6E6E6',
                                            }}>
                                                +65
                                            </div>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} pt={2}>
                                <Stack direction="row" spacing={2} gap={1}>
                                    <CustomButton
                                        title="Save changes"
                                        press={() => {
                                            handlesubmit();
                                            setIsEdit(false);
                                        }}
                                        backgroundColor="#1D1B1B"
                                        textColor="white"
                                        height="36px"
                                        width="150px"
                                    />
                                    <CustomButton
                                        title="Cancel"
                                        press={() => {
                                            setIsEdit(false);
                                            setFormValues({
                                                name: details?.name || "",
                                                email: details?.email || "",
                                                phone: details?.phone || "",
                                                profile_photo: details?.profile_photo_path,
                                                profile_photo_name: details?.profile_photo_name,
                                                profile_photo_extension: details?.profile_photo_extension,
                                                joined_date: details?.joined_date === "0000-00-00" ? null : details?.joined_date,
                                            });
                                        }}
                                        backgroundColor={"#F9F9F9"}
                                        textColor="#808588"
                                        height="36px"
                                        width="115px"
                                        borderStyle={width > 768 ? undefined : "none"}
                                    />
                                </Stack>
                            </Grid>
                        </Grid>

                        </div>
                            
                    );
            case 'password_security':
                return (
                    <div>
                        {/* <Stack spacing={2} pb={3}>
                            <span style={{ fontSize: "16px", fontWeight: 600 }}>Password & Security</span>
                        </Stack> */}
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Current password"
                                    values={values?.current_password || ''}
                                    onChange={(e) => handleFormObjectChange('current_password', e)}
                                    placeholder="Enter current password"
                                    paddingBlock="8px"
                                    typePw={showPasswords.current ? "text" : "password"}
                                    InputProps={{
                                        endAdornment: (
                                            <IconButton
                                                onClick={() => setShowPasswords(prev => ({...prev, current: !prev.current }))}
                                                edge="end"
                                                style={{ padding: 0, marginRight: 2 }}
                                            >
                                                <Icon icon={showPasswords.current ? "solar:eye-linear" : "solar:eye-closed-linear"} width={20} height={20} color="#808588" />
                                            </IconButton>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <CustomTextField
                                    title="New password"
                                    values={values?.new_password || ''}
                                    onChange={(e) => handleFormObjectChange('new_password', e)}
                                    placeholder="Enter new password"
                                    paddingBlock="8px"
                                    typePw={showPasswords.new ? "text" : "password"}
                                    InputProps={{
                                        endAdornment: (
                                            <IconButton
                                                onClick={() => setShowPasswords(prev => ({...prev, new: !prev.new }))}
                                                edge="end"
                                                style={{ padding: 0, marginRight: 2 }}
                                            >
                                                <Icon icon={showPasswords.new ? "solar:eye-linear" : "solar:eye-closed-linear"} width={20} height={20} color="#808588" />
                                            </IconButton>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Confirm new password"
                                    values={values?.new_password_confirmation || ''}
                                    onChange={(e) => handleFormObjectChange('new_password_confirmation', e)}
                                    placeholder="Re-enter new password"
                                    paddingBlock="8px"
                                    typePw={showPasswords.confirm ? "text" : "password"}
                                    InputProps={{
                                        endAdornment: (
                                            <IconButton
                                                onClick={() => setShowPasswords(prev => ({...prev, confirm: !prev.confirm }))}
                                                edge="end"
                                                style={{ padding: 0, marginRight: 2 }}
                                            >
                                                <Icon icon={showPasswords.confirm ? "solar:eye-linear" : "solar:eye-closed-linear"} width={20} height={20} color="#808588" />
                                            </IconButton>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} pt={2}>
                                <CustomButton
                                    title="Save changes"
                                    press={() => {
                                        handlesubmit();
                                    }}
                                    backgroundColor="#1D1B1B"
                                    textColor="white"
                                    height="36px"
                                    width={width > 768 ? "150px" : "100%"}
                                />
                            </Grid>
                        </Grid>
                    </div>
                );
            default:
                return "";
        }
    }

    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: width <= 768 && leftSideBarType === 'condensed' ? 72 : 0, backgroundColor: width > 768 ? "#f5f6fa" : "white" }}>
                <Container fluid>
                    <LoadingDialog open={loading} />
                    <Notification notification={notification} setNotification={setNotification} />

                {width > 768 ? (
                    <Card style={{ padding: "30px", borderRadius: 5, minHeight: "100vh" }}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Stack className="sticky-side-tabs" sx={{paddingLeft: 4, paddingTop: 2}} spacing={2}>
                                    <span style={{ fontSize: "20px", fontWeight: 600, paddingBottom: "20px", cursor: "pointer" }}>Profile </span>
                                    <div style={{ color: selected === "store_details" ? "black" : "#808588", cursor: "pointer" }} onClick={(e) => setSelected("store_details")}> <Icon icon="solar:shop-bold-duotone" className="me-2" /> Store Details</div>
                                    <div style={{ color: selected === "salesman" ? "black" : "#808588", cursor: "pointer" }} onClick={(e) => setSelected("salesman")}><Icon icon="solar:case-minimalistic-bold-duotone" className="me-2" /> Salesman</div>
                                    <div style={{ color: selected === "team_members" ? "black" : "#808588", cursor: "pointer" }} onClick={(e) => setSelected("team_members")}><Icon icon="solar:users-group-two-rounded-bold-duotone" className="me-2" /> Team Members</div>
                                    <div style={{ color: selected === "profile_info" ? "black" : "#808588", cursor: "pointer" }} onClick={(e) => {setSelected("profile_info"); setIsEdit(false)}}><Icon icon="solar:user-bold-duotone" className="me-2" /> Profile Info</div>
                                    <div style={{ color: selected === "password_security" ? "black" : "#808588", cursor: "pointer" }} onClick={(e) => setSelected("password_security")}><Icon icon="solar:lock-keyhole-minimalistic-bold-duotone" className="me-2" /> Password & Security</div>
                                </Stack>
                            </Grid>
                            <Grid item xs={8} sx={{marginTop: 2}}>
                                {renderContent()}
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <div style={{ fontSize: "20px", fontWeight: 600, marginBottom: "16px" }}>Profile</div>
                            <div style={{
                                position: 'sticky',
                                top: 0,
                                backgroundColor: 'white',
                                zIndex: 100,
                                marginBottom: '16px',
                            }}>
                            <Stack direction="row" spacing={2} style={{ overflowX: 'auto', paddingBottom: '8px', }}>
                                <div
                                    onClick={() => setSelected("store_details")}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        gap: '8px',
                                        minWidth: 'fit-content',
                                        cursor: 'pointer',
                                        color: selected === "store_details" ? "black" : "#808588",
                                        paddingRight: '16px'
                                    }}
                                >
                                    <Icon icon="solar:shop-bold-duotone" width={16} height={16} />
                                    <span style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Store Details</span>
                                </div>
                                <div
                                    onClick={() => setSelected("salesman")}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        gap: '8px',
                                        minWidth: 'fit-content',
                                        cursor: 'pointer',
                                        color: selected === "salesman" ? "black" : "#808588",
                                        paddingRight: '16px'
                                    }}
                                >
                                    <Icon icon="solar:case-minimalistic-bold-duotone" width={16} height={16} />
                                    <span style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Salesman</span>
                                </div>
                                <div
                                    onClick={() => setSelected("team_members")}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        gap: '8px',
                                        minWidth: 'fit-content',
                                        cursor: 'pointer',
                                        color: selected === "team_members" ? "black" : "#808588",
                                        paddingRight: '16px'
                                    }}
                                >
                                    <Icon icon="solar:users-group-two-rounded-bold-duotone" width={16} height={16} />
                                    <span style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Team Members</span>
                                </div>
                                <div
                                    onClick={() => setSelected("profile_info")}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        gap: '8px',
                                        minWidth: 'fit-content',
                                        cursor: 'pointer',
                                        color: selected === "profile_info" ? "black" : "#808588",
                                        paddingRight: '16px'
                                    }}
                                >
                                    <Icon icon="solar:user-bold-duotone" width={16} height={16} />
                                    <span style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Profile Info</span>
                                </div>
                                <div
                                    onClick={() => setSelected("password_security")}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        gap: '8px',
                                        minWidth: 'fit-content',
                                        cursor: 'pointer',
                                        color: selected === "password_security" ? "black" : "#808588",
                                        paddingRight: '16px'
                                    }}
                                >
                                    <Icon icon="solar:lock-keyhole-minimalistic-bold-duotone" width={16} height={16} />
                                    <span style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Password & Security</span>
                                </div>
                            </Stack>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            {renderContent()}
                        </Grid>
                    </Grid>
                )}
                </Container>

            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Profile, General, Layout }) {
    console.log("sfdsf", Layout)
    return {
        details: {
            store_name: "Auto Works",
            type: "Dealer",
            count: 12,
            name: "",
            registration_number: "123456789",
            short_business_description: "We are a leading car dealership offering a wide range of vehicles to suit every need and budget.",
            website_url: "https://www.autoworks.com",
            banner_image: "/images/store/banner_sample.png",
            cover_image: "/images/store/cover_sample.png",
            salesman: [
                { salesman_name: "John Doe", location: "Downtown", phone_number: "123-456-7890", status: "default" },
                { salesman_name: "Jane Smith", location: "Uptown", phone_number: "987-654-3210", status: 0 },
                { salesman_name: "Jane Smith", location: "Uptown", phone_number: "987-654-3210", status: 1 },
                { salesman_name: "Jane Smith", location: "Uptown", phone_number: "987-654-3210", status: 2 },
                { salesman_name: "Jane Smith", location: "Uptown", phone_number: "987-654-3210", status: 3 },
            ],
            operating_hours: [
                { day: "Monday", opening_time: "9:00 AM", closing_time: "6:00 PM" },
                { day: "Tuesday", opening_time: "9:00 AM", closing_time: "6:00 PM" },
                { day: "Wednesday", opening_time: "9:00 AM", closing_time: "6:00 PM" },
                { day: "Thursday", opening_time: "9:00 AM", closing_time: "6:00 PM" },
                { day: "Friday", opening_time: "9:00 AM", closing_time: "6:00 PM" },
                { day: "Saturday", opening_time: "10:00 AM", closing_time: "4:00 PM" },
                { day: "Sunday", opening_time: "Closed", closing_time: "Closed" },
            ],
            latitude: "1.3521",
            longitude: "103.8198",
        },
        editUserProfile: Profile.editProfile,
        editUserPwd: Profile.editUserPwd,
        error: Profile.error?.errors,
        profileImgBase64: General.attachment,
        userPermission: Login.permissionArry,
        leftSideBarType: Layout.leftSideBarType,
    };
}

export default connect(mapStateToProps)(UserProfile);
